import { useState, useEffect } from "react";

/**
 * Reusable hook to persist state in sessionStorage across page refreshes.
 * Drop-in replacement for useState.
 *
 * @param {string} key - Unique storage key
 * @param {any} defaultValue - Initial value if nothing is stored
 * @returns {[any, Function]} - [state, setState]
 */
export const usePersistedState = (key, defaultValue) => {
  const [state, setState] = useState(() => {
    try {
      const saved = sessionStorage.getItem(key);
      return saved !== null ? JSON.parse(saved) : defaultValue;
    } catch (error) {
      console.warn(`Error reading sessionStorage key "${key}":`, error);
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      if (state === null || state === undefined) {
        sessionStorage.removeItem(key);
      } else {
        sessionStorage.setItem(key, JSON.stringify(state));
      }
    } catch (error) {
      console.warn(`Error writing sessionStorage key "${key}":`, error);
    }
  }, [key, state]);

  return [state, setState];
};

export default usePersistedState;
